import { TYPES } from 'action-types/download-selections';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IStore } from 'reducers/index';

export const saveSelectedRows = (rowData: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.SAVE_TABLE_SELECTIONS, payload: rowData });
    };
};

export const updateSelectedRows = (rowData: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.UPDATE_TABLE_SELECTIONS, payload: rowData });
    };
};

export const resetSelectedRows = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.RESET_TABLE_SELECTIONS });
    };
};